<template>
  <div v-if="hasWetsuit()" class="container main__diving main--sticky-bottom">
    <el-dialog
      :show-close="true"
      :visible="wetSuitSizeDialogVisible"
      center
      custom-class="diving__size-dialog"
      @close="wetSuitSizeDialogVisible = false"
    >
      <template slot="title"
        ><h2 class="diving__size-dialog-title">Wetsuit Size Chart</h2>
      </template>
      <div class="diving__size-dialog-table-header">Adult</div>
      <el-table
        :data="adultWetSuitSizeData"
        :resizable="false"
        fit
        style="margin-bottom: 40px"
      >
        <el-table-column label="Sizes" prop="size"></el-table-column>
        <el-table-column label="Chest (cm)" prop="chest"></el-table-column>
        <el-table-column label="Waist (cm)" prop="waist"></el-table-column>
        <el-table-column label="Hip (cm)" prop="hip"></el-table-column>
        <el-table-column label="Height (cm)" prop="height"></el-table-column>
        <el-table-column label="Height (ft)" prop="heightFt"></el-table-column>
        <el-table-column label="Weight (kg)" prop="weightKg"></el-table-column>
      </el-table>

      <div class="diving__size-dialog-table-header">Children</div>
      <el-table :data="childWetSuitSizeData" :resizable="false" fit>
        <el-table-column label="Sizes" prop="size"></el-table-column>
        <el-table-column label="Chest (cm)" prop="chest"></el-table-column>
        <el-table-column label="Waist (cm)" prop="waist"></el-table-column>
        <el-table-column label="Hip (cm)" prop="hip"></el-table-column>
        <el-table-column label="Height (cm)" prop="height"></el-table-column>
        <el-table-column label="Height (ft)" prop="heightFt"></el-table-column>
      </el-table>
    </el-dialog>

    <el-collapse ref="formRoot" v-model="activeCollapseIndexes">
      <el-collapse-item
        v-for="(contactBooking, index) in contactBookings"
        :key="contactBooking.contactID"
        :name="index"
        class="el-collapse-item--diving"
      >
        <!--<div class="label-mandatory">fields with <span class="indicator-mandatory">*</span> are mandatory</div>-->
        <template slot="title" class="title">
          <span class="guest-number">GUEST {{ index + 1 }}/</span
          >{{ getFullNameByContactId(contactBooking.contactID) }}
        </template>
        <el-form
          :model="contactBooking"
          :rules="ruleValidate"
          label-position="left"
        >
          <el-radio-group
            :value="contactBooking.needAWetsuit === true"
            class="diving__planning-to-dive"
            @input="
              onContactBookingInputChange(
                contactBooking.contactID,
                'needAWetsuit',
                $event,
              )
            "
          >
            <el-radio :label="true"> I need a wetsuit. </el-radio>
            <el-radio :label="false"> I don't need a wetsuit. </el-radio>
          </el-radio-group>
          <div
            v-if="
              contactBooking.needAWetsuit === true ||
              contactBooking.needAWetsuit === 'true' ||
              false
            "
            style="height: 100%"
          >
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="Wetsuit size" prop="wetsuit">
                  <v-select
                    :ref="'wetsuitSelect' + contactBooking.contactID"
                    :options="selectWetsuit"
                    :reduce="(item) => item.value"
                    :searchable="false"
                    :value="contactBooking.wetsuit"
                    filterable
                    label="label"
                    @input="
                      onContactBookingInputChange(
                        contactBooking.contactID,
                        'wetsuit',
                        $event,
                      )
                    "
                    v-on:search:focus="onWetsuitFocus(contactBooking.contactID)"
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col v-if="contactBooking.wetsuit === 'Other'" :gutter="16">
                <el-form-item label="Wetsuit size (other)" prop="wetsuitOther">
                  <el-input
                    :rows="6"
                    :value="contactBooking.wetsuitOther"
                    placeholder=""
                    @input="
                      onContactBookingInputChange(
                        contactBooking.contactID,
                        'wetsuitOther',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div>
              <!--              <i class="icon icon-measurement diving__size-icon"></i>-->
              <span class="diving__size-links">
                Size charts:
                <a @click="wetSuitSizeDialogVisible = true">Wetsuit</a>
              </span>
            </div>
          </div>
        </el-form>
      </el-collapse-item>
    </el-collapse>

    <div class="sticky-bottom">
      <el-row class="bottom-nav" justify="space-between" type="flex">
        <el-button
          :disabled="isSaving"
          class="button--secondary bottom-nav__secondaryButton"
          @click="onClickBack"
          >Back</el-button
        >

        <autosave-indicator />
        <el-button
          :disabled="isSaving"
          class="button--tertiary bottom-nav__secondaryButton"
          @click="onClickSaveAndExit(false)"
          >Save
        </el-button>
        <el-button
          :disabled="isSaving"
          class="button--primary bottom-nav__primaryButton"
          @click="onClickNext"
          >Next</el-button
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import types from "../store/types";
import {
  ADULT_WETSUIT_SIZE_DATA,
  CHILD_WETSUIT_SIZE_DATA,
  DIVING_WETSUIT,
  UNHANDLED_ERROR_MESSAGE,
} from "../constants";
import contactMixin from "../mixins/contact";
import autosave from "../mixins/autosave";
import { timeTrack } from "../mixins/timeTrack";
import AutosaveIndicator from "./AutosaveIndicator";
import { delay, padTime, positionDropdown, waitUntil } from "../utils";

const DELIMITER = ";";

export default {
  props: {
    index: Number,
  },
  mixins: [contactMixin, timeTrack, autosave],
  components: { AutosaveIndicator },
  mounted() {
    this.initializeAutosave(
      this.onClickSaveAndExit.bind(this),
      this.$refs.formRoot,
    );
  },
  created() {
    gtag("set", "page_path", "/step-3c");
    gtag("event", "page_path", {
      path: "/step-3c",
    });
  },
  data() {
    const contacts = this.$store.getters["contacts"];
    const contactBookings = this.$store.getters["contactBookings"];

    // Creates a local model in order for Select multiple component to work
    // actual update state is done in onContactInputChange
    const validationConfig = {
      required: true,
      message: "Required",
      trigger: "change blur",
    };
    const ruleValidate = {};

    return {
      activeCollapseIndexes: this.index
        ? [this.index]
        : contacts.map((contact, index) => index),
      wetSuitSizeDialogVisible: false,
      selectWetsuit: DIVING_WETSUIT,
      adultWetSuitSizeData: ADULT_WETSUIT_SIZE_DATA,
      childWetSuitSizeData: CHILD_WETSUIT_SIZE_DATA,
      ruleValidate,
    };
  },
  computed: {
    ...mapGetters([
      types.getters.contacts,
      types.getters.contact,
      types.getters.contactBookings,
      types.getters.booking,
      types.getters.isSaving,
    ]),
  },
  methods: {
    ...mapActions([
      types.actions.updateContactField,
      types.actions.updateContactBookingField,
      types.actions.updateBookingField,
      types.actions.updateContactsRemote,
      types.actions.updateContactsAndBookingRemote,
      types.actions.setIsVisibleDialogSaveAndExit,
    ]),
    getContactByContactId(contactID) {
      return this.contact(contactID);
    },
    onContactInputChange: function (contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      const value = Array.isArray(event) ? event.join(DELIMITER) : event;
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });
    },
    onContactBookingInputChange: async function (contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      const value = Array.isArray(event) ? event.join(DELIMITER) : event;
      // The user can still edit the field while an autosave is happening,
      // so we should wait until the saving has completed before updating the field again
      await waitUntil(() => !this.isSaving);
      if (fieldName === "wetsuit" && event !== "Other") {
        // Clear the Diving Wetsuit Other field
        this[types.actions.updateContactBookingField]({
          contactID,
          fieldName: "wetsuitOther",
          value: "",
        });
      }

      this[types.actions.updateContactBookingField]({
        contactID,
        fieldName,
        value,
      });
    },

    onBookingInputChange: function (fieldName, event) {
      console.log("[fieldName, event]", fieldName, event);

      this[types.actions.updateBookingField]({
        fieldName,
        value: event,
      });
    },
    //prevents dropdown from getting cut off
    async onWetsuitFocus(contactID) {
      const select = this.$refs[`wetsuitSelect${contactID}`][0];
      await delay(1);
      const dropdown =
        select.$el.querySelector(".vs__dropdown-menu") ||
        document.querySelector(
          "body > .vs__dropdown-menu:not(.vs__fade-leave-active)",
        );
      if (!dropdown) {
        return;
      }
      positionDropdown(select.$el, dropdown);
      dropdown.style.width = "inherit";
    },
    async onClickSaveAndExit(isAutosaving = false) {
      try {
        const res = await this.saveDataToRemote(isAutosaving);
        if (isAutosaving) {
          return res;
        } else {
          this.setIsVisibleDialogSaveAndExit(true);
        }
      } catch (error) {
        this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        return false;
      }

      return true;
    },
    onClickNext: function () {
      this.saveDataToRemote()
        .then((res) => {
          this.$router.push("step-4");
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    onClickBack: function () {
      this.saveDataToRemote()
        .then((res) => {
          this.$router.back();
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    saveDataToRemote(isAutosave = false) {
      const { contacts, booking, contactBookings } = this;
      return this.updateContactsAndBookingRemote({
        contacts,
        booking,
        contactBookings,
        showLoader: !isAutosave,
        workflowTrigger: !isAutosave, // defer Zoho workflows until user explicitly saves
      });
    },
  },
};
</script>

<style lang="scss">
@import "../scss/icon";
@import "../scss/typography";
@import "../scss/color";

.el-collapse-item__content {
  border-radius: 0 0 4px 4px;
  border: 1px solid $aqua-grey-75;
  border-width: 0 1px 1px 1px;
  padding-bottom: 30px;
}

.diving__size-dialog {
  min-width: 890px;

  &--large {
    min-width: 1016px;
  }

  .el-dialog__headerbtn {
    position: fixed;

    i {
      @extend .icon-close-white;
    }
  }

  .el-dialog__body {
    padding: 0 64px 64px 64px;

    table {
      text-transform: uppercase;
      margin-left: auto;
      margin-right: auto;

      th,
      td {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }

    .el-table__header {
      th {
        @include global-paragraph-small-bold;
        background-color: $aqua-grey-10;
        border-right: 1px solid #e7e7e7;
        color: #4a4a4a;

        &:first-child {
          border-left: 1px solid #e7e7e7;
        }
      }

      th.dark {
        @include global-paragraph-small-bold;
        background-color: $aqua-grey-100;
        border-right: 1px solid $aqua-grey-100;
        color: white;

        &:first-child {
          border-left: 1px solid $aqua-grey-100;
        }
      }
    }

    .el-table__body {
      td {
        @include global-paragraph-small-regular;
        border-right: 1px solid #e7e7e7;

        &:first-child {
          border-left: 1px solid #e7e7e7;
        }
      }
    }
  }
}

.el-collapse-item--diving {
  .el-collapse-item {
    &__header {
      padding-left: 114px;
    }
  }

  .guest-number {
    position: absolute;
    top: 50%;
    left: 40px;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    transform: translateY(-50%);
  }

  .el-form-item__content {
    /*width: 60%;*/
  }

  .el-select ~ .el-textarea {
    margin-top: 16px;
  }
}
</style>
<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

hr {
  margin-top: 48px;
  margin-bottom: 48px;
  border-top: 0;
  border-bottom: 1px solid $hr-color;
}

.h1-title {
  margin-bottom: 32px;
}

.special-request {
  padding: 48px 40px;
  background-color: #fff;

  .el-form-item__label {
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 18px;
  }
}

.main__diving {
  h3 {
    @include typo-bold(20);
    margin-bottom: 32px;
  }
}

.alert {
  margin-bottom: 32px;

  &__title {
    @include typo-bold(16);
  }

  &__list {
    margin-top: 4px;
    margin-bottom: 0;
  }
}

.diving {
  &__planning-to-dive {
    padding: 24px 0;
  }

  &__size-icon {
    background-position-y: bottom;
  }

  &__size-dialog-title {
    @include global-paragraph-x-large-bold;
  }

  &__size-dialog-table-header {
    @include global-paragraph-medium-bold;
    background-color: $aqua-grey-100;
    color: white;
    padding: 8px 16px;
  }

  &__size-links {
    @include global-paragraph-medium-regular;
    color: $aqua-grey-100;

    a {
      @include global-paragraph-medium-regular;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}

.underage-note {
  border-radius: 4px;
  background-color: #ecf1f5;
  padding: 16px 32px;
  display: flex;
  align-items: center;

  &__icon {
    background-size: contain;
    margin-right: 32px;
  }

  &__content {
  }

  &__title {
    @include typo-bold(16);
  }

  &__message {
    @include typo(16);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WetsuitPage.vue